<script>
export default {
  functional: true,

  props: {
    icon: { type: String, default: null }
  },

  render(h, { slots, props, data }) {
    const classes = [
      "workout-group-header__detail d-flex align-items-center",
      data.class,
      data.staticClass
    ]

    return (
      <span class={classes}>
        {props.icon && <v-icon class="mr-1" icon={props.icon} size="1.5rem" />}
        <p class="mb-0 mt-0">{slots().default}</p>
      </span>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.workout-group-header__detail {
  margin-right: $size--3;

  .v-icon {
    opacity: 0.3;
  }
}
</style>
